const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPos1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m467 225h-148v-179c0-24.813-20.187-45-45-45h-229c-24.813 0-45 20.187-45 45v420c0 24.813 20.187 45 45 45h229c24.813 0 45-20.187 45-45v-19h148c24.813 0 45-20.187 45-45v-132c0-24.813-20.187-45-45-45zm0 30c8.271 0 15 6.729 15 15v19h-163v-34zm-178 211c0 8.271-6.729 15-15 15h-229c-8.271 0-15-6.729-15-15v-420c0-8.271 6.729-15 15-15h229c8.271 0 15 6.729 15 15zm178-49h-148v-98h163v83c0 8.271-6.729 15-15 15z",
    fill: "#ffffff",
    "data-original": "#000000",
    style: {}
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m110.71 285.07c-1.876-8.95-10.721-13.911-19.07-11.42-8.479 2.763-12.229 11.179-9.99 18.71 2.82 8.625 11.344 12.224 18.7 9.99 7.811-2.501 11.739-9.911 10.36-17.28z",
    fill: "#ffffff",
    "data-original": "#000000",
    style: {}
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m168.33 275.53c-11.089-7.3-25.52 2.152-23.04 15.4 2.561 12.339 18.048 16.391 26.31 6.58 5.791-7.338 3.829-17.181-3.27-21.98z",
    fill: "#ffffff",
    "data-original": "#000000",
    style: {}
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m238.71 285.07c-1.89-9.017-10.863-13.917-19.061-11.42-8.376 2.673-12.271 11.071-10 18.71 2.794 8.544 11.19 12.226 18.71 9.99 7.866-2.572 11.719-9.974 10.351-17.28z",
    fill: "#ffffff",
    "data-original": "#000000",
    style: {}
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m110.71 349.07c-1.862-8.885-10.653-13.931-19.07-11.42-8.479 2.763-12.229 11.18-9.99 18.71 2.82 8.625 11.344 12.224 18.7 9.99 7.805-2.499 11.74-9.906 10.36-17.28z",
    fill: "#ffffff",
    "data-original": "#000000",
    style: {}
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m168.33 339.53c-11.106-7.312-25.517 2.166-23.04 15.4 2.561 12.339 18.048 16.391 26.31 6.58 5.752-7.29 3.886-17.143-3.27-21.98z",
    fill: "#ffffff",
    "data-original": "#000000",
    style: {}
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m238.71 349.07c-1.881-8.974-10.83-13.928-19.061-11.42-8.601 2.745-12.227 11.366-10 18.7 2.695 8.417 11.089 12.266 18.71 10 7.826-2.559 11.725-9.941 10.351-17.28z",
    fill: "#ffffff",
    "data-original": "#000000",
    style: {}
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m110.71 413.07c-1.862-8.885-10.653-13.931-19.07-11.42-8.602 2.803-12.201 11.273-9.99 18.71 2.819 8.623 11.362 12.218 18.7 9.99 7.728-2.474 11.754-9.833 10.36-17.28z",
    fill: "#ffffff",
    "data-original": "#000000",
    style: {}
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m168.33 403.53c-7.478-4.923-17.287-2.417-21.561 5.41-5.881 11.514 3.832 24.08 16.16 21.77 13.188-2.747 16.396-19.747 5.401-27.18z",
    fill: "#ffffff",
    "data-original": "#000000",
    style: {}
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m238.71 413.07c-1.886-8.999-10.847-13.922-19.061-11.42-8.286 2.644-12.291 11.004-10 18.71 2.81 8.596 11.241 12.211 18.71 9.99 7.788-2.546 11.735-9.885 10.351-17.28z",
    fill: "#ffffff",
    "data-original": "#000000",
    style: {}
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m240 65h-160c-8.284 0-15 6.716-15 15v128c0 8.284 6.716 15 15 15h160c8.284 0 15-6.716 15-15v-128c0-8.284-6.716-15-15-15zm-15 128h-130v-98h130z",
    fill: "#ffffff",
    "data-original": "#000000",
    style: {}
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPos1);
export default __webpack_public_path__ + "static/media/pos1.433f66007de06b7f20c8369d373c7c35.svg";
export { ForwardRef as ReactComponent };